import React from "react";
import { graphql, PageProps } from "gatsby";

import { SEO } from "../components/common/seo";
import { Contact } from "../components/Pages/Contact";

interface ContactDataProps {
  data: {
    frontmatter: {
      content: string;
      form: boolean;
      newsletter: boolean;
      contact_information?: string;
    };
  };
}

const ContactPage: React.FC<PageProps<ContactDataProps>> = ({ data }) => {
  return (
    <>
      <SEO title="Contact" />

      <Contact
        content={data.data.frontmatter.content}
        form={data.data.frontmatter.form}
        information={data.data.frontmatter.contact_information}
      />
    </>
  );
};

// eslint-disable-next-line import/no-default-export
export default ContactPage;

export const query = graphql`
  query ContactQuery {
    data: markdownRemark(fileAbsolutePath: { regex: "/contact.md/" }) {
      frontmatter {
        content
        form
        contact_information
      }
    }
  }
`;
